import React, { useState } from 'react';
import { Form } from 'react-bootstrap';

const FilterDropdown = ({ onFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState({
    all: true,
    active: false,
    inactive: false
  });

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleFilterChange = (filterType) => {
    if (filterType === 'all') {
      // When clicking All, uncheck other filters
      const newFilters = {
        all: true,
        active: false,
        inactive: false
      };
      setFilters(newFilters);
      onFilterChange('all');
    } else {
      // When clicking Active or Inactive
      const newFilters = {
        ...filters,
        all: false,
        [filterType]: !filters[filterType]
      };
      setFilters(newFilters);

      // If no filter is selected, default to "All"
      if (!newFilters.active && !newFilters.inactive) {
        setFilters({
          all: true,
          active: false,
          inactive: false
        });
        onFilterChange('all');
        return;
      }

      // Determine filter status based on checkboxes
      if (newFilters.active && newFilters.inactive) {
        onFilterChange('both');
      } else if (newFilters.active) {
        onFilterChange('active');
      } else if (newFilters.inactive) {
        onFilterChange('inactive');
      }
    }
  };

  // Handle clicking outside to close dropdown
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.filter-dropdown')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative filter-dropdown">
      <button 
        className="btn-square btn btn-primary mx-2"
        onClick={toggleDropdown}
      >
        <i className="icon-filter"></i>
      </button>

      {isOpen && (
        <div className="position-absolute bg-white rounded shadow-sm border" style={{ 
          right: 0, 
          top: '95%', 
          marginTop: '-10px',
          marginLeft: '0px',  
          marginRight: '20px',        
          zIndex: 1000,
          minWidth: '150px',
          padding: '10px'
        }}>
          <Form>
            <Form.Check
              type="checkbox"
              id="filter-all"
              label="All"
              checked={filters.all}
              onChange={() => handleFilterChange('all')}
              className="mb-2"
            />
            {/* <Form.Check
              type="checkbox"
              id="filter-active"
              label="Active User"
              checked={filters.active}
              onChange={() => handleFilterChange('active')}
              className="mb-2"
            /> */}
            <Form.Check
              type="checkbox"
              id="filter-inactive"
              label="Inactive User"
              checked={filters.inactive}
              onChange={() => handleFilterChange('inactive')}
            />
          </Form>
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;